module.exports = __webpack_public_path__ + "static/media/forgot-desktop-bg.f8c28375.png";